/**
 * @generated SignedSource<<7b9e2c8d8d8086c918c989751c5e806a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateCustomFieldDropdownOptionsInput = {
  customFieldDefinitionId: string;
  options: ReadonlyArray<CustomFieldDropdownOptionInputType>;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CustomFieldDropdownOptionInputType = {
  id?: string | null;
  displayName: string;
};
export type UpdateCustomFieldDropdownOptionsMutation$variables = {
  input: UpdateCustomFieldDropdownOptionsInput;
};
export type UpdateCustomFieldDropdownOptionsMutation$data = {
  readonly updateCustomFieldDropdownOptions: {
    readonly options: ReadonlyArray<{
      readonly id: string;
      readonly displayName: string;
    } | null> | null;
  } | null;
};
export type UpdateCustomFieldDropdownOptionsMutation$rawResponse = {
  readonly updateCustomFieldDropdownOptions: {
    readonly options: ReadonlyArray<{
      readonly id: string;
      readonly displayName: string;
    } | null> | null;
  } | null;
};
export type UpdateCustomFieldDropdownOptionsMutation = {
  variables: UpdateCustomFieldDropdownOptionsMutation$variables;
  response: UpdateCustomFieldDropdownOptionsMutation$data;
  rawResponse: UpdateCustomFieldDropdownOptionsMutation$rawResponse;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCustomFieldDropdownOptionsPayload",
    "kind": "LinkedField",
    "name": "updateCustomFieldDropdownOptions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomFieldDropdownOption",
        "kind": "LinkedField",
        "name": "options",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateCustomFieldDropdownOptionsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateCustomFieldDropdownOptionsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "87d12a9115d5bed44c18e2090d2d5b61",
    "id": null,
    "metadata": {},
    "name": "UpdateCustomFieldDropdownOptionsMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateCustomFieldDropdownOptionsMutation(\n  $input: UpdateCustomFieldDropdownOptionsInput!\n) {\n  updateCustomFieldDropdownOptions(input: $input) {\n    options {\n      id\n      displayName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "869b309b3127a6100a78d3ca9d1e183f";

export default node;
